import { gql, useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { ISetServiceModeResponse, SET_SERVICE_MODE } from 'schemas';
import notification from 'services/notificationService';

import { TSetServiceMode } from './interfaces';

export const useSetServiceMode = (
  t: TTranslator<TLocalesKeys>
): TSetServiceMode => {
  const [setServiceMode] = useMutation<ISetServiceModeResponse>(
    SET_SERVICE_MODE,
    {
      update: (cache, { data }) => {
        const host = data?.setHostServiceMode;

        if (!host) return;

        cache.writeFragment({
          id: cache.identify({ ...host, __typename: 'HostOverview' }),
          data: { ...host, __typename: 'HostOverview' },
          fragment: gql`
            fragment serviceMode on HostOverview {
              in_service
            }
          `,
        });
      },
      onCompleted: ({ setHostServiceMode: { in_service, alias } }) => {
        notification.info({
          t,
          leftDescription: alias,
          title: t(
            in_service ? 'host.notify.service.on' : 'host.notify.service.off'
          ),
          type: 'warning',
          dismiss: 5,
        });
      },
    }
  );

  return setServiceMode;
};
